import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignalRStatusViewerComponent } from './signalR-status-viewer/signalR-status-viewer.component';


@NgModule({
    declarations: [SignalRStatusViewerComponent],
    imports: [
        CommonModule,
        MatIconModule,
        FlexLayoutModule

    ],
    exports: [SignalRStatusViewerComponent],
})
export class SignalRStatusViewerModule { }
